import { Svg } from "components/base/svg/Svg";
import { AssetsDirectory } from "@finbackoffice/enums";
import { FC, useMemo } from "react";
import { useSportFeedType } from "hooks";

type IProps = {
    categoryId: number;
};

const CategoryIcon: FC<IProps> = ({ categoryId }) => {
    const { isBCFeed } = useSportFeedType();

    const iconsDirectory = useMemo(() => {
        let path = "";

        if (isBCFeed) {
            path += `${AssetsDirectory.BCFeed}/`;
        } else {
            path += `${AssetsDirectory.BRFeed}/`;
        }

        return path;
    }, [isBCFeed]);

    const id = useMemo(() => {
        if (isBCFeed) {
            return categoryId & 0xffff;
        }
        return categoryId;
    }, [categoryId, isBCFeed]);

    return (
        <Svg
            src={`/${AssetsDirectory.Common}/${iconsDirectory}${AssetsDirectory.Regions}/${id}.svg`}
            className="svg-region-icon"
            loader
        />
    );
};

export default CategoryIcon;
